import React, { useState } from 'react';
import { Grid, Box,  RadioGroup, FormControlLabel, Radio, CircularProgress } from '@mui/material';
import { BasicCard } from '../../shared/basicCard';
import { BasicErrorLabel } from '../../shared/basicErrorLabel';
import { updateTeamCardEditStatusApi } from '../../api/orgSeasonApi';
import { useOrgSeasonContext } from '../../context/orgSeasonContext';
import { BasicButton } from '../../shared/basicButton';
import { useApiCallWithAuth } from '../../hooks/useApiCallWithAuth';
import { Team } from '../../api/models/team';
import { BasicDatePicker } from '../../shared/basicDatePicker';

export interface CardEditPanelProps {
	team: Team;
}

export function CardEditPanel(props: CardEditPanelProps) {
	const [canViewCardData, setCanViewCardData] = useState<boolean>(props.team.canViewCardData);
	const [canEditCardData, setCanEditCardData] = useState<boolean>(props.team.canEditCardData);
	const [editCardDataExpirationDate, setEditCardDataExpirationDate] = useState<string>(props.team.editCardDataExpirationDate?.toString() || '');
	const [editCardDataFinalDate, setEditCardDataFinalDate] = useState<string>(props.team.editCardDataFinalDate?.toString() || '');

	const [errorMessage, setErrorMessage] = useState<string>('');
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const updateTeamCardEditStatusApiRequest = useApiCallWithAuth(updateTeamCardEditStatusApi);

	const { orgSeason, refreshOrgSeason } = useOrgSeasonContext();

	async function updateData() {

		setIsLoading(true);
		setErrorMessage('');

        try{

            await updateTeamCardEditStatusApiRequest.request(orgSeason?.id, props.team.id, {
                canViewCardData,
                canEditCardData,
                editCardDataExpirationDate:editCardDataExpirationDate,
                editCardDataFinalDate:editCardDataFinalDate
            });
            refreshOrgSeason();
        }
        catch (error) {
            console.error('Error updating card edit status:', error);
            setErrorMessage('Failed to update card edit status. Please try again.');
        }

		setIsLoading(false);

    }

	return (
		<>
			<Grid container spacing={3} alignItems="center">
				<Grid item>
					<h3>Card Edit Panel</h3>
				</Grid>
			</Grid>
			<BasicCard>
				<Box>
					<Grid item container spacing={2} direction="row" alignItems="center" sx={{ mb: 2 }}>
					<Grid item>
        <RadioGroup
            row
            value={canEditCardData ? 'edit' : canViewCardData ? 'view' : 'none'}
            onChange={(e) => {
                const value = e.target.value;
                setCanEditCardData(value === 'edit');
                setCanViewCardData(value === 'view' || value === 'edit');
            }}
        >
            <FormControlLabel value="none" control={<Radio />} label="None" />
            <FormControlLabel value="view" control={<Radio />} label="Can View" />
            <FormControlLabel value="edit" control={<Radio />} label="Can Edit" />
        </RadioGroup>
    </Grid>
					</Grid>

					{orgSeason && (
						<Box>
							<Grid container spacing={1} sx={{ mb: 2 }}>
								<Grid>

								<BasicDatePicker width={250} 
								                 label='Edit Final Date'
												 value= {editCardDataExpirationDate}
												 onChange={(date) => setEditCardDataExpirationDate(date ? date:'')}/>
								</Grid>

                                <Grid sx={{ ml: 2 }}>


								<BasicDatePicker width={250} 
								                 label='Final Cutoff Date'
												 value= {editCardDataFinalDate}
												 onChange={(date) => setEditCardDataFinalDate(date ? date:'')}/>
								</Grid>

							
							</Grid>

								<Box sx={{ mt: 2 }}>
									{!isLoading && <BasicButton onClick={updateData} labelText="Update" />}
									{isLoading && <CircularProgress/>}	
								</Box>
							{errorMessage && <BasicErrorLabel errors={[errorMessage]} />}
						</Box>
					)}
				</Box>
			</BasicCard>
		</>
	);
}
